import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CalendarDays } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function YearSelector({ year, onChange }) {
  const { t } = useT();
  const now = new Date().getFullYear();
  // Range: 5 years back → 2 years ahead
  const years = [];
  for (let y = now - 5; y <= now + 2; y++) years.push(y);

  return (
    <div
      className="inline-flex items-center gap-2 rounded-lg border border-[#272A35] bg-[#131620] pl-3 pr-1 py-1"
      data-testid="year-selector"
    >
      <CalendarDays className="h-3.5 w-3.5 text-[#D4AF37]" />
      <span className="text-[10px] uppercase tracking-[0.18em] text-slate-400 font-medium hidden sm:inline">
        {t("chip.yearForQuickEntry")}
      </span>
      <Select value={String(year)} onValueChange={(v) => onChange(parseInt(v, 10))}>
        <SelectTrigger
          className="h-7 w-[86px] bg-[#0C0E14] border-[#272A35] text-slate-100 font-mono-terminal text-sm focus:ring-1 focus:ring-[#D4AF37]"
          data-testid="year-selector-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#131620] border-[#272A35]">
          {years.map((y) => (
            <SelectItem
              key={y}
              value={String(y)}
              className="font-mono-terminal text-slate-200 focus:bg-[#272A35] focus:text-white"
              data-testid={`year-option-${y}`}
            >
              {y}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
